//update broadcast
export const UPDATE_BROADCAST_REQUEST = "UPDATE_BROADCAST_REQUEST";
export const UPDATE_BROADCAST_RECEIVE = "UPDATE_BROADCAST_RECEIVE";
export const UPDATE_BROADCAST_FAILURE = "UPDATE_BROADCAST_FAILURE";
export const RESET_UPDATE_BROADCAST= "RESET_UPDATE_BROADCAST";